<template>
  <div class="date-input-wrapper" :class="{ 'has-error': error }">
    <input
      ref="actualInput"
      type="date"
      v-model="internalValue"
      :min="min"
      :max="max"
      @input="onChange(internalValue)"
      class="date-field-input"
      :style="{ minWidth: minWidth ? minWidth + 'px' : 'auto' }"
    />
    <div :class="['v-input__details', { 'invisible': !error }]" role="alert" aria-live="polite">
      <div class="v-messages">
        <div class="v-messages__message" v-for="(msg, i) in errorMessages" :key="i">{{ msg }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: [String, Date],
  minWidth: Number,
  rules: Array,
  min: String,
  max: String,
})

const emit = defineEmits(['submit', 'formIsInvalid'])

const internalValue = ref(null)
const errorMessages = ref([])
const error = ref(false)
const actualInput = ref(null)

function validate(val = null) {
  if (val === null) {
    val = internalValue.value
  }
  errorMessages.value = []

  for (const rule of props.rules || []) {
    let result
    try {
      result = rule(val)
    } catch (e) {
      result = e.message || 'Validation error'
    }

    if (result !== true) {
      error.value = true
      errorMessages.value.push(result)
      emit('formIsInvalid')
      return false
    }
  }

  error.value = false
  return true
}

function submit(val) {
  emit('submit', val)
}
function onChange(val) {

  if (validate(val)) {
    submit(val)
  }
}
defineExpose({
  validate,
  focus() {
    actualInput.value.focus()
  },
  scrollIntoView(e) {
    actualInput.value.scrollIntoView(e)
  },
  resetValidation() {
    errorMessages.value = []
    error.value = false
  }
})

watch(() => props.modelValue, (val) => {
  internalValue.value = val
}, { immediate: true })

</script>

<style scoped>
.date-field-input {
  padding: 8px;
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 6px;
  width: 100%;
}
.date-field-input:focus {
  outline: none;
}
.has-error .date-field-input {
  border-color: #d32f2f;
}
</style>